<template>
  <div id="header">
    <div id="banner">
      <div class="wrap">
        <NvaH />

        <swiper
          v-if="$store.state.menuIndex == 0 && ($route.name == 'Index' || !$route.name) && $route.name !== 'indexDetail'"
          class="swiper"
          :options="swiperOption"
        >
          <swiper-slide v-for="(item, index) in deviceList" :key="index">
            <div class="swiper-zoom-container banner-slide">
              <img :src="item.imgUrl" class="swiper-img" />
              <div v-if="item.displayTitle || item.displayDescription" class="banner-copy">
                <p v-if="item.displayDescription" class="banner-copy__title">{{ item.displayDescription }}</p>
                <h2 v-if="item.displayTitle" class="banner-copy__description">{{ item.displayTitle }}</h2>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
        </swiper>

        <div v-if="$store.state.menuIndex == 1 && $route.name == 'Dealer'" @click="goTo">
          <!-- <img class="banner-dealer" src="@/assets/banner_help_dark.png" alt="" /> -->
          <div class="banner-dealer">
            <p id='banner-dealer_bigTitle'>{{ $t("header.立即與OTTBUS合作吧！") }}</p>
            <p id='banner-dealer_smallTitle'>{{ $t("header.加入我們，開啓賺錢的旅程！") }}</p>
            <el-button  plain round id="banner-dealer_button">{{ $t("header.馬上開始") }}</el-button>
          </div>
        </div>

        <div v-if="$store.state.menuIndex == 2 && $route.name == 'Help'" class="banner-help">
          <div class="help-box">
            <div class="title">{{ $t("header.helpTitle") }}</div>
            <div class="help-search-box">
              <i class="el-icon-search"></i>
              <input
                v-model="helpSearchKeyword"
                type="text"
                :placeholder="$t('helpPage.searchPlaceholder')"
                @keyup.enter="handleHelpSearch"
              />
            </div>
          </div>
        </div>

        <div v-if="$store.state.menuIndex > 2" class="banner-user">
          <img class="banner-dealer" src="@/assets/banner_helpH_dark.png" alt="" />
          <div class="user-title">
            <span v-if="$store.state.menuIndex == 3">{{ $t("header.subscriptionTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 4">{{ $t("header.userCenterTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 5">{{ $t("header.myPromotionTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 6">{{ $t("header.orderTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 7">{{ $t("header.myWalletTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 8">{{ $t("header.myCouponsTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 9">{{ $t("header.couponCenterTitle") }}</span>
            <span v-else-if="$store.state.menuIndex == 10">{{ $t("header.registerCouponTitle") }}</span>
            <span v-else>{{ $t("header.userCenterTitle") }}</span>
          </div>
        </div>

        <div v-if="$store.state.menuIndex == 0 && $route.name == 'indexDetail'" class="banner-detail"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import NvaH from "@/components/NavH.vue";
import { getArticleLlist } from "@/api/article.js";
import { normalizeBannerList } from "@/utils/banner";

export default {
  name: "HeaderH",
  components: {
    NvaH,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        zoom: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      helpSearchKeyword: "",
      rawDeviceList: [],
    };
  },
  computed: {
    deviceList() {
      return normalizeBannerList(this.rawDeviceList, this.$i18n.locale);
    },
  },
  created() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      try {
        const res = await getArticleLlist({
          code: "m_banner",
        });
        this.rawDeviceList = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.rawDeviceList = [];
      }
    },
    goTo() {
      if (this.$store.state.isMobile) {
        this.$router.push({ path: "/dealer/detail" });
      }
    },
    handleHelpSearch() {
      const keyword = this.helpSearchKeyword.trim();
      if (keyword) {
        this.$bus.$emit("helpSearch", keyword);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#header {
  width: 100vw;

  #banner {
    .wrap {
      width: 100%;
      height: 100%;

      .swiper {
        width: 100%;
        height: 100%;

        .banner-slide {
          position: relative;
        }

        .swiper-img {
          max-height: 500px;
          width: 100%;
          object-fit: cover;
          pointer-events: none;
        }

        .banner-copy {
          position: absolute;
          left: 18px;
          right: 18px;
          bottom: 14px;
          padding: 18px 16px;
          border-radius: 18px;
          // background: linear-gradient(180deg, rgba(10, 19, 41, 0.08) 0%, rgba(10, 19, 41, 0.78) 100%);
          color: #fff;
          z-index: 2;
          width: 60%;
        }

        .banner-copy__title {
          margin: 0;
          //font-size: 42px;
          line-height: 1.25;
          font-size: 10px;
          font-weight: 700;
        }

        .banner-copy__description {
          margin: 8px 0 0;
          font-size: 6px;
          line-height: 1.6;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.92);
        }
      }

      ::v-deep .swiper-pagination-bullet {
        background: #ffffff !important;
        opacity: 1;
      }

      ::v-deep .swiper-pagination-bullet-active {
        width: 20px !important;
        height: 8px !important;
        border-radius: 4px !important;
        background: #ffffff !important;
      }
    }
  }

  .banner-dealer {
    width: 100%;
    pointer-events: none;
    height: 200px;
    position: relative;
    flex: 1;
    background: url(../assets/banner_help_dark.png) no-repeat center;
    text-align: center;
    overflow: hidden;
    #banner-dealer_bigTitle{ 
      margin: 50px auto;
      font-size:20px;
      color:#fff;
      margin-bottom:0;
    }
    #banner-dealer_smallTitle {
      margin: 10px auto;
      font-size:10px;
      color:#fff;
      margin-bottom:0;
    }
   #banner-dealer_button{
      font-size:10px;
      margin-top:10px;
      
    }
  }

  .banner-help {
    width: 100vw;
    position: relative;
    background: url(../assets/banner_helpH_dark.png) no-repeat center top;
    background-size: cover;
    padding-bottom: 20px;

    .help-box {
      position: relative;
      padding: 60px 20px 0;
    }

    .title {
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      font-weight: 700;
      margin-bottom: 25px;
      line-height: 1.3;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    .help-search-box {
      display: flex;
      align-items: center;
      height: 46px;
      background: #fff;
      border-radius: 23px;
      padding: 0 20px;
      box-shadow: 0 4px 15px rgba(29, 64, 255, 0.15);

      i {
        font-size: 16px;
        color: #1d40ff;
        margin-right: 12px;
      }

      input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
        background: transparent;

        &::placeholder {
          color: #aaa;
        }
      }
    }
  }

  .banner-user {
    width: 100vw;
    position: relative;

    img.banner-dealer {
      width: 100%;
      height: 180px;
      object-fit: cover;
    }

    .user-title {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      color: #ffffff;
      font-size: 22px;
      font-weight: bold;
      text-align: center;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
  }

  .banner-detail {
    width: 100vw;
    height: 0;
    background: transparent;
  }
}
</style>
